import React from 'react';

export const AppContext = React.createContext({
    showingLoadingIcon: false,
    onFirstFullResImageLoaded: null,
    setLoadingIconVisibility: null,
    currentSceneName: null,
    setCurrentSceneName: null,
    setSpotifyModalVisibility: null,
    showSpotifyModal:null,
    currentScene:null
});
